export default "__VITE_ASSET__BqlM9KjK__"